import { render, staticRenderFns } from "./HomeIcon.vue?vue&type=template&id=8f62b25c"
import script from "./HomeIcon.vue?vue&type=script&lang=ts"
export * from "./HomeIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports